<script>
  export let allowed = [];
  export let id = '';
</script>

{#if allowed.includes(id)}
  <slot />
{/if}
